export default __webpack_public_path__ + "static/media/title.e7548f30.jpg";